import React from 'react'
import { Outlet } from 'react-router'

export const AuthLayout: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Outlet />
    </div>
  )
} 